<header><div class="logo"><img src="@/assets/df-logo.svg" alt=""></div><p>Demand<span>Navigator</span></p></header>